import { Link } from 'react-router-dom';
import { Phone, MapPin, Clock } from 'lucide-react';

const CRM_URL = process.env.REACT_APP_CRM_URL || 'https://crm.phillyrideshare.com';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <img src="/logo.png" alt="Fair Rideshare" className="w-11 h-11 rounded-xl" />
              <div className="leading-none">
                <span className="block font-display font-bold text-xl text-white">Fair Rideshare</span>
                <span className="block text-[10px] font-semibold tracking-[0.18em] text-slate-500 mt-1">PHILADELPHIA · LLC</span>
              </div>
            </div>
            <p className="text-slate-400 max-w-sm leading-relaxed">
              Philadelphia's premier weekly rental for rideshare drivers and everyday commuters. Insurance-ready, mileage-friendly, no long contracts.
            </p>
          </div>

          <div className="md:col-span-4">
            <h3 className="eyebrow mb-4">Contact</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-amber-500" />
                <span>215-770-0679</span>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-amber-500" />
                <span>Philadelphia, PA</span>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-amber-500" />
                <span>7 days · 9am – 9pm</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="eyebrow mb-4">Links</h3>
            <ul className="space-y-3 text-sm">
              <li><a href={`${CRM_URL}/book`} className="hover:text-white transition-colors">Available cars</a></li>
              <li><Link to="/#how" className="hover:text-white transition-colors">How it works</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><a href={`${CRM_URL}/login`} className="hover:text-white transition-colors">Staff login</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-14 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            © {new Date().getFullYear()} Fair Rideshare LLC. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-slate-500">
            <Link to="/privacy" className="hover:text-white cursor-pointer transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white cursor-pointer transition-colors" data-testid="footer-terms-link">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
